module.exports = __webpack_public_path__ + "img/TA.f91fd2dc.png";